module.exports = __webpack_public_path__ + "img/Ill_Badge_Login_Failed.661d35bb.svg";